import {
  AssetTrackerHiddenItemOpacity,
  CardBorderRadius,
} from 'features/overview/utils/siteViewTheme'
import React, { FC } from 'react'
import { styled } from 'styled-components'

const CountDisplayContainer = styled.div<{ $focused: boolean }>`
  display: flex;
  opacity: ${({ $focused }) => ($focused ? 1 : AssetTrackerHiddenItemOpacity)};
  flex-direction: row;
  justify-content: center;
  place-items: center;
  font-size: 0.5rem;
  height: max-content;
  font-weight: bold;

  transition: opacity 0.2s ease-in-out;
`

const NumberDisplay = styled.span<{
  $backgroundColor: string
  $borderColor?: string
}>`
  background: ${({ $backgroundColor }) => $backgroundColor};
  border: ${({ $borderColor }) =>
    $borderColor ? `0.1rem solid ${$borderColor}` : 'none'};
  color: ${({ theme }) => theme.forecast.activeText};
  margin: 0.1rem;
  padding: 0.1rem 0.15rem;
  border-radius: ${CardBorderRadius};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: max-content;
`

const LabelDisplay = styled.span``

export const SiteViewAssetTrackerCountDisplay: FC<{
  label: string
  count: number
  backgroundColor: string
  borderColor?: string
  focused?: boolean
}> = (props) => {
  return (
    <CountDisplayContainer $focused={props.focused ?? true}>
      <NumberDisplay
        $backgroundColor={props.backgroundColor}
        $borderColor={props.borderColor}>
        {props.count}
      </NumberDisplay>
      <LabelDisplay> {props.label} </LabelDisplay>
    </CountDisplayContainer>
  )
}
